import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { Home, Key, Star } from 'lucide-react';
export const Services = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].services;
  const icons = [<Home key="home" size={40} strokeWidth={1} className="text-[#c9a96e] mb-8" data-id="element-243" data-mp="18twg0inhgzh2" />, <Key key="key" size={40} strokeWidth={1} className="text-[#c9a96e] mb-8" data-id="element-244" data-mp="13wmuvf74n9z1" />, <Star key="star" size={40} strokeWidth={1} className="text-[#c9a96e] mb-8" data-id="element-245" data-mp="z4wd4o5v1jxl" />];
  return <FadeInSection id="services" className="w-full bg-[#1a1a1a] py-24 lg:py-32" data-id="element-246" data-mp="u6l4uhv7rhhh">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-247" data-mp="q5hqjzstdtid">
        <div className="flex flex-col items-center text-center mb-20" data-id="element-248" data-mp="l5dj0z9vw94a">
          <span className="eyebrow mb-4" data-id="element-249" data-mp="l4ll3hstdzau">{t.eyebrow}</span>
          <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-white" data-id="element-250" data-mp="g60mtnx4hpp1">
            {t.headline}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-251" data-mp="36amxqpthdjth">
          {t.cards.map((card, index) => <div key={index} className="group relative bg-[#2a2a2a] p-10 lg:p-12 transition-all duration-500 hover:-translate-y-2" data-id="element-252" data-mp="2xbrrjdqfs9q6" data-mpi={index}>
              {/* Hover Border Effect */}
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#c9a96e] scale-y-0 origin-bottom group-hover:scale-y-100 transition-transform duration-500 ease-out" data-id="element-253" data-mp="3q0qd6ktrpu08" />

              {icons[index]}

              <h3 className="font-serif-display text-2xl text-white mb-4" data-id="element-254" data-mp="3g2smzrscln4z">
                {card.title}
              </h3>

              <p className="body-text text-gray-400 text-sm md:text-base" data-id="element-255" data-mp="3l0avxi6d82cz">
                {card.desc}
              </p>
            </div>)}
        </div>
      </div>
    </FadeInSection>;
};